export class RikData {

  constructor(data: any) {
    if (data === null) {
      throw new Error('RikData: data mustn\'t be null');
    }
    if (typeof data !== 'object') {
      throw new Error('RikData: data must be an object');
    }
    if (RikData.isArray(data)) {
      throw new Error('RikData: data mustn\'t be an array');
    }
    this.data = data;
  }

  private data: any;

  public static isArray(value: any): boolean {
    return value && typeof value === 'object' && value.constructor === Array;
  }

  public static isNumeric(n: any): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  public requireExists(propertyName: string): any {
    const value = this.data[propertyName];
    if (typeof value === 'undefined') {
      throw new Error('Required property missing: ' + propertyName);
    }
    return value;
  }

  public getBool(propertyName: string): boolean {
    const value = this.data[propertyName];
    if (!value) {
      return false;
    }
    if (RikData.isNumeric(value)) {
      // eslint-disable-next-line eqeqeq
      return value != 0;
    }
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value !== 'string') {
      return false;
    }
    return value !== 'false';
  }

  getEnumString(propertyName: string, clazz: any, def: any = null): any {
    const keys = Object.keys(clazz).filter(key => clazz[key] === this.data[propertyName]);
    return keys.length > 0 ? clazz[keys[0]] : def;
  }
}
